import { useState } from 'react';
import './index.less';
import { Pagination } from '../../core/ui';
import { list } from './list';

const BlogPage = () => {

    const data = [
        ...list
    ].map((t, i) => {
        // @ts-ignore
        t.id = i + 1;
        return t;
    });

    const pageSize = 8;
    const [pageIndex, setPageIndex] = useState(1);
    const onPageChange = (page: number) => {

        setPageIndex(page);
    }

    return (
        <div className='page-container'>
            {/* <section className="site-section-small section-blog"> */}

            <div className="container">
                <div className="text-center">
                    <h1 className="section-title-big">前端技术</h1>
                    <p className="section-text" style={{ maxWidth: '660px' }}>
                        我们着力打造完善的技术体系、通过技术创造价值、结合新技术开发各种有趣的开源项目 ！
                        <br />
                        我们提倡劳逸结合，展现自我, 做事专业，严谨，乐于分享, 希望每个人都能够快乐工作，认真生活 ！
                    </p>
                </div>

                {/* <ol className="breadcrumb">
                            <li><a>Home</a></li>
                            <li className="active">Blog</li>
                        </ol> */}

                <div className="row">
                    <div className="col-md-9">
                        {
                            // @ts-ignore
                            data.filter(item => item.id > pageSize * (pageIndex - 1) && item.id <= pageSize * pageIndex).map(item => {

                                return (
                                    // @ts-ignore
                                    <div className="blog-post" key={item.id}>
                                        <div className="post-content">

                                            <h3>
                                                <a className="post-title" href={item.link} target="_blank">{item.title}</a>
                                            </h3>

                                            <p className="section-text">
                                                {item.description}
                                            </p>

                                            {/* <ul className="post-meta list-unstyled">
                                                    <li><a>Business</a></li>
                                                    <li><a>2 15, 2022</a></li>
                                                    <li><a>2 Comments</a></li>
                                                </ul> */}

                                        </div>
                                    </div>
                                );
                            })
                        }

                        {/* <div className="text-center">
                            <ul className="pagination">
                                <li><a><<</a></li>
                                <li><a><</a></li>
                                <li><a>4</a></li>
                                <li className="active"><a>5</a></li>
                                <li><a>6</a></li>
                                <li><a>></a></li>
                                <li><a>>></a></li>
                            </ul>
                        </div> */}

                    </div>

                    <aside className="col-md-3">

                        <div className="sidebar">

                            <div className="widget search-form">
                                <form>
                                    <input className="form-control" type="search" placeholder="Search" />
                                    <button type="submit">
                                        <span className="glyphicon glyphicon-search"></span>
                                    </button>
                                </form>
                            </div>

                            <div className="widget widget-categories">
                                <h4 className="widget-title">分类</h4>

                                <ul className="list-unstyled">
                                    <li><a>Design</a></li>
                                    <li><a>Photograpy</a></li>
                                    <li><a>News</a></li>
                                    <li><a>Typography</a></li>
                                    <li><a>Fashion</a></li>
                                </ul>
                            </div>

                            {/* <div className="widget widget-latest-posts">
                                    <h4 className="widget-title">Latest Posts</h4>

                                    <ul className="list-unstyled posts-list">
                                            <li>
                                                <a>
                                                    <div className="widget-thumb">
                                                        <img className="img-carousel" src="assets/img/portfolio-7.jpg" alt="" />
                                                    </div>
                                                    <div className="widget-post-info">
                                                        <h4 className="widget-post-title">Business Perfect is the best Free Theme</h4>
                                                        <p className="widget-post-date">Sep 25, 2015</p>
                                                    </div>
                                                </a>
                                            </li>

                                            <li>
                                                <a>
                                                    <div className="widget-thumb">
                                                        <img className="img-carousel" src="assets/img/portfolio-8.jpg" alt="" />
                                                    </div>
                                                    <div className="widget-post-info">
                                                        <h4 className="widget-post-title">We provide unique solutions</h4>
                                                        <p className="widget-post-date">Sep 23, 2015</p>
                                                    </div>

                                                </a>
                                            </li>

                                            <li>
                                                <a>
                                                    <div className="widget-thumb">
                                                        <img className="img-carousel" src="assets/img/portfolio-9.jpg" alt="" />
                                                    </div>
                                                    <div className="widget-post-info">
                                                        <h4 className="widget-post-title">We are creative minds</h4>
                                                        <p className="widget-post-date">Sep 22, 2015</p>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                </div> */}

                            <div className="widget widget-tags">
                                <h4 className="widget-title">标签</h4>
                                <ul className="list-unstyled">
                                    <li><a>Multipurpose</a></li>
                                    <li><a>Creative</a></li>
                                    <li><a>Elegant</a></li>
                                    <li><a>Clean</a></li>
                                    <li><a>Modern</a></li>
                                    <li><a>Responsive</a></li>
                                    <li><a>Wordpress</a></li>
                                    <li><a>Corporate</a></li>
                                </ul>
                            </div>

                        </div>

                    </aside>

                </div>

                <div className="ui-pagination my-90 mb-0">
                    {/* <h3 class="section-title-small text-center mb-50">Pagination</h3> */}
                    <div className="row">
                        <div className="col-md-12 text-center">
                            {/* <ul className="pagination">
                                <li><a><<</a></li>
                                <li><a><</a></li>
                                <li className="more"><a>...</a></li>
                                <li><a>31</a></li>
                                <li className="active"><a>32</a></li>
                                <li><a>33</a></li>
                                <li className="more"><a>...</a></li>
                                <li><a>></a></li>
                                <li><a>>></a></li>
                            </ul> */}
                            <Pagination current={pageIndex} pageSize={pageSize} defaultCurrent={1} onChange={onPageChange} total={data.length} />
                        </div>
                    </div>
                </div>
            </div>

            {/* </section> */}
        </div>
    );
}

export default BlogPage;
